import { render } from "./AudioPlayerSticky.vue?vue&type=template&id=fa8a31de&scoped=true"
import script from "./AudioPlayerSticky.vue?vue&type=script&lang=js"
export * from "./AudioPlayerSticky.vue?vue&type=script&lang=js"

import "./AudioPlayerSticky.vue?vue&type=style&index=0&id=fa8a31de&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa8a31de"]])

export default __exports__